import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { updateUserInfo } from "@/api"
import { SchemaResponse, User } from "@/modules/types"

const useUpdateInfo = (
  options: UseMutationOptions<SchemaResponse<null>, Error, Partial<User>> = {}
) => {
  return useMutation({
    mutationFn: async (data: Partial<User>) => {
      const response = await updateUserInfo(data)
      return response.data
    },
    ...options
  })
}

export default useUpdateInfo
